import React from "react";
import PropTypes from "prop-types";
import { TextField as RMDTextField } from "react-md";

const TextField = ({
  label,
  innerRef,
  ...otherProps
}) => (
    <>
      {label}
      <div className="mgridform-value">
        <RMDTextField
          ref={innerRef}
          {...otherProps}
        />
      </div>
    </>
  );

TextField.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  innerRef: PropTypes.object,
};

export default TextField;